import React from "react";

const LogoUpload = ({ logoUrl, onFileChange, errors = [] }) => {
  return (
    <div
      className={errors.length ? "form-group row validated" : "form-group row"}
    >
      <label className="col-xl-3 col-lg-3 col-form-label">Logo</label>
      <div className="col-lg-9 col-xl-6">
        <div className="kt-avatar kt-avatar--outline" id="kt_user_add_avatar">
          <div className="kt-avatar__holder" style={{ textAlign: "center" }}>
            <img
              id="Image1"
              src={logoUrl}
              alt="logo"
              style={{
                maxWidth: "115px",
                maxHeight: "115px",
                textAlign: "center",
              }}
            />
          </div>
          <label
            className="kt-avatar__upload"
            id="files"
            data-toggle="kt-tooltip"
            title="Change avatar"
          >
            <i className="fa fa-pen" />
            <input
              type="file"
              id="file"
              name="kt_user_add_user_avatar"
              onChange={onFileChange}
              accept="image/*"
            />
          </label>
          <span
            className="kt-avatar__cancel"
            data-toggle="kt-tooltip"
            title="Cancel avatar"
          >
            <i className="fa fa-times" />
          </span>
        </div>
        {errors.length > 0 && (
          <div className="invalid-feedback d-block">
            {errors.map((error, index) => (
              <div key={index}>{error}</div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LogoUpload;
